import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { toast } from 'sonner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireBroker?: boolean;
  requireBrokerOrAdmin?: boolean;
  requireBrokerage?: boolean;
  orBrokerage?: boolean;
}

export default function ProtectedRoute({ 
  children, 
  requireAdmin = false, 
  requireBroker = false,
  requireBrokerOrAdmin = false,
  requireBrokerage = false,
  orBrokerage = false
}: ProtectedRouteProps) {
  const { user, loading, rolesLoading, isAdmin, isBroker, canAccessBrokerage } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      toast.error('Du måste logga in för att komma åt denna sida');
    } else if (!rolesLoading && requireAdmin && !isAdmin) {
      toast.error('Du har inte behörighet att komma åt denna sida');
    } else if (!rolesLoading && requireBroker && !isBroker) {
      toast.error('Du har inte behörighet att komma åt denna sida');
    } else if (!rolesLoading && requireBrokerOrAdmin && !isAdmin && !isBroker && !(orBrokerage && canAccessBrokerage)) {
      toast.error('Du har inte behörighet att komma åt denna sida');
    } else if (!rolesLoading && requireBrokerage && !isAdmin && !canAccessBrokerage) {
      toast.error('Du har inte behörighet till företagsmäkleri');
    }
  }, [user, loading, rolesLoading, requireAdmin, requireBroker, requireBrokerOrAdmin, requireBrokerage, orBrokerage, isAdmin, isBroker, canAccessBrokerage]);

  if (loading || rolesLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
          <p className="mt-2 text-muted-foreground">Laddar...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  if (requireBroker && !isBroker) {
    return <Navigate to="/" replace />;
  }

  if (requireBrokerOrAdmin && !isAdmin && !isBroker && !(orBrokerage && canAccessBrokerage)) {
    return <Navigate to="/" replace />;
  }

  if (requireBrokerage && !isAdmin && !canAccessBrokerage) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
